/* ============================================
   Every Paw Matters — Policy Table of Contents
   Auto-generates a clickable index from h2 headings.
   Add inline in theme.liquid (see instructions below)
   ============================================ */
(function () {
  var body = document.querySelector('.shopify-policy__body .rte');
  if (!body) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length < 3) return; // skip TOC for very short pages

  // assign IDs to each h2
  headings.forEach(function (h, i) {
    h.id = 'section-' + (i + 1);
  });

  // build TOC
  var toc = document.createElement('nav');
  toc.className = 'policy-toc';
  toc.setAttribute('aria-label', 'Table of contents');

  var title = document.createElement('p');
  title.className = 'policy-toc__title';
  title.textContent = 'In this policy';
  toc.appendChild(title);

  var list = document.createElement('ul');
  list.className = 'policy-toc__list';

  headings.forEach(function (h, i) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    // keep the full heading text including section number
    a.textContent = h.textContent;
    a.href = '#section-' + (i + 1);
    li.appendChild(a);
    list.appendChild(li);
  });

  toc.appendChild(list);

  // insert after the intro paragraphs (before first hr)
  var firstHr = body.querySelector('hr');
  if (firstHr) {
    firstHr.parentNode.insertBefore(toc, firstHr);
  } else {
    body.insertBefore(toc, body.firstChild);
  }
})();
